import React from "react";
import Select from "~components/Form/components/Select";
import { CleanFiltersIcon, SearchAdd } from "~misc/icons";
import {Link} from "react-router-dom";
import useParametros from "~fetchs/useParametros";

const TrackMappingFilter = ({
  grupoProdutoOptions = [],
  orderOptions = [],
  filters = {},
  onFilterChange,
  onClearFilters,
  onAdicionarGrupo,
  verPropostasLink,
}) => {

  const { toObjectSlug } = useParametros();
  const shouldShowVerPropostasLink = toObjectSlug?.["disponibilizar-redirecionamento-propostas"]?.valor?.toLowerCase() === "sim";

  return (
    <div>
      <div className="flex justify-end py-4 border-b mb-4">
        {shouldShowVerPropostasLink && (
          <Link
            type="button"
            target="_blank"
            rel="noopener noreferrer"
            to={verPropostasLink}
            className="bg-secundaria text-primaria hover:brightness-90 opacity-100 flex justify-between items-center gap-4 p-4 md:ml-4 md:mt-0 mt-2 rounded-lg font-bold button-search"
          >
            <span>Ver Propostas de Concreto</span>
          </Link>
        )}
        <button
          type="button"
          onClick={onAdicionarGrupo}
          className="bg-primaria text-white opacity-100 flex justify-between items-center gap-4 p-4 md:ml-4 md:mt-0 mt-2 rounded-lg font-bold button-search"
        >
          <span>Adicionar Grupo de Produto</span>
          <SearchAdd className="icon" size="20" />
        </button>
      </div>

      <div className="flex items-end justify-between py-2 mb-8">
        <div className="w-52">
          <Select
            options={grupoProdutoOptions}
            label="Grupo de Produto:"
            name="grupoProduto"
            placeholder="Selecione"
            value={filters.grupoProduto}
            onChange={(option) => onFilterChange?.("grupoProduto", option)}
            spacingControl={true}
          />
        </div>

        <div className="flex items-center gap-4">
          <Select
            options={orderOptions}
            label="Ordenar por:"
            name="orderBy"
            placeholder="Selecione"
            value={filters.orderBy}
            onChange={(option) => onFilterChange?.("orderBy", option)}
            variation="compact-inline"
            spacingControl={true}
          />

          <button
            type="button"
            onClick={onClearFilters}
            className="flex items-center gap-2 mb-4 text-sm font-semibold text-primaria"
          >
            <span>Limpar Filtros</span>
            <CleanFiltersIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrackMappingFilter;
